export default __webpack_public_path__ + "static/media/previewLoader.96ecb80e.gif";